export const QUERY_ADDON_PREFIX = 'addon'
export const QUERY_COUPON = 'coupon'
export const QUERY_PRICES = 'prices'
export const QUERY_REVALIDATE = 'revalidate'
export const QUERY_QUICK_PICK = 'quickpick'
export const QUERY_QUICK_PICK_BET_TYPE = 'quickpick_bet_type'
export const QUERY_QUICK_PICK_NUMBERS = 'quickpick_numbers'
export const QUERY_QUICK_PICK_WAGER = 'quickpick_wager'
export const QUERY_SUBSCRIPTION = 'subscription'
